export const PROXY_URL = "https://obd3api.nspl.cloud/proxypass";

export const USER_ROLES={
  ADMIN: "ROLE_ADMIN",
  USER: "ROLE_USER",
  S_ADMIN: "ROLE_SADMIN",
  SUB_USER: "ROLE_SUSER",
  SUB_SUPER_ADMIN: "ROLE_SUB_SADMIN",
}
export const STATUS_PRIORITY = {
  'Processing': 0,
  'Running': 1,
  'Complete': 2,
  'Paused': 3,
  'Timeout_Paused': 4,
  'Ready': 5,
  'Low Balance': 6,
  'Error': 7,
  'Cancelling': 8,
  'Cancelled': 9,
  'Pausing': 10,
  'Resuming': 11,
  'Timeout_Pausing': 12,
  'System Cancelled': 13,
  'System Complete': 14,
};
export const STATUS_MAP = {
	'Ready': 0,
	'Processing': 21,
	'Running': 1,
	'Complete': 2,
	'Low Balance': 3,
	'Error': [4, 5],
	'Cancelling': 6,
	'Cancelled': 7,
	'Pausing': 8,
	'Paused': 9,
	'Resuming': 10,
	'Timeout_Pausing': 22,
	'Timeout_Paused': 23,
  'System Cancelled': 12,
  'System Complete': 11,
};

export const STATUS_CODE_TO_LABEL = Object.entries(STATUS_MAP).reduce(
  (acc, [label, code]) => {
    if (Array.isArray(code)) {
      code.forEach(c => (acc[c] = label));
    } else {
      acc[code] = label;
    }
    return acc;
  },
  {}
);

export const TEMPLATES = {
  0: 'Simple IVR',
  1: 'DTMF',
  2: 'Call Patch',
  3: 'Custom IVR',
  4: 'Multi IVR',
  6: 'Inbound Call Patch',
  7: 'TTS Simple IVR',
  8: 'TTS DTMF',
  9: 'TTS Call Patch'
};

export const SAMPLE_JSON = {
  "campaign_id": "campaign_id",
  "user_id": "user_id",
  "cli": "cli",
  "mobile": "mobile",
  "answer_status": "answer_status",
  "dtmf": "dtmf",
  "call_sid": "call_sid",
  "start_time": "start_time",
  "answer_time": "answer_time",
  "end_time": "end_time",
  "billing_duration": "billing_duration",
  "hangup_cause": "hangup_cause",
  "patch_duration": "patch_duration",
  "bridge_ring_duration": "bridge_ring_duration",
  "campaign_name": "campaign_name",
  "retry_count": "retry_count",
  "agent_number": "agent_number",
  "agent_answer_time": "agent_answer_time",
  "bridge_hangup_cause": "bridge_hangup_cause",
  "recording_file": "recording_file"
};

export const DTMF_KEYS = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "*", "#"];
export const ACTION_COLORS = {
    answer: "green",
    gather: "purple",
    hangup: "red",
    play: "#007bff",
    transfer: "orange",
    record: "#20c997"
};
export const IVR_SETTING_ORDER=["answer", "play", "gather", "record", "hangup",]

export const THIRTY_SECONDS = 30000;
export const FORTY_FIVE_SECONDS = 45000;

export const BASE_PERMISSON={
  READ:"read",
  ADD:"add",
  EDIT:"edit",
  DELETE:"delete",
  VIEW_PERMISSION:"view_permission",
}

export const MODULE_LISTING_CONSTANT={
  MANAGE_API_CLI:"Manage API CLI",
  MANAGE_CLI:"Manage CLI",
  MANAGE_DIALERS:"Manage Dialers",
  MANAGE_GROUPS:"Manage Groups",
  MANAGE_LOCATIONS:"Manage Locations",
}